import { render, staticRenderFns } from "./ProductImageDisplay.vue?vue&type=template&id=73dd39c6&scoped=true"
import script from "./ProductImageDisplay.vue?vue&type=script&lang=js"
export * from "./ProductImageDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductImageDisplay.vue?vue&type=style&index=0&id=73dd39c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dd39c6",
  null
  
)

export default component.exports